module.exports = __webpack_public_path__ + "img/dating.251a0b0.png";